import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { LoadingView } from "@/components";
import { usePairAnalysis } from "@/context/PairAnalysisContext";
import { PairMetric, pairMetricConfig } from "@trader-dashboard/shared";
import { AnalysisTimeFrameSelector } from "./AnalysisTimeFrameSelector";
import { PairSelector } from "./PairSelector";
import { PairAnalysisChart } from "./PairAnalysisChart";

export const PairsAnalysisTab = (): React.ReactNode => {
  const {
    loading, error, timeFrame, setTimeFrame, customRange, setCustomRange,
    metric, setMetric, allPairs, hiddenPairs, togglePair, showAllPairs,
    hideAllPairs, analysis,
  } = usePairAnalysis();

  if (loading) return <LoadingView />;
  if (error) return <p className="text-red-500">Error: {error}</p>;

  return (
    <Card>
      <CardHeader>
        <div className="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
          <div>
            <CardTitle>{pairMetricConfig[metric].title}</CardTitle>
            <CardDescription>{pairMetricConfig[metric].description}</CardDescription>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <AnalysisTimeFrameSelector
              timeFrame={timeFrame}
              onTimeFrameChange={setTimeFrame}
              customRange={customRange}
              onCustomRangeChange={setCustomRange}
            />
            <Tabs value={metric} onValueChange={(v) => setMetric(v as PairMetric)}>
              <TabsList className="h-8">
                {(Object.keys(pairMetricConfig) as PairMetric[]).map((key) => (
                  <TabsTrigger key={key} value={key} className="px-3 py-1 text-xs">
                    {pairMetricConfig[key].label}
                  </TabsTrigger>
                ))}
              </TabsList>
            </Tabs>
          </div>
        </div>
      </CardHeader>
      <CardContent className="grid gap-4">
        <PairSelector
          pairs={allPairs}
          hiddenPairs={hiddenPairs}
          onTogglePair={togglePair}
          onShowAll={showAllPairs}
          onHideAll={hideAllPairs}
        />
        <PairAnalysisChart analysis={analysis} metric={metric} />
      </CardContent>
    </Card>
  );
};
